var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('typo',{class:_vm.cspClasses,attrs:{"name":"ci-body"},domProps:{"innerHTML":_vm._s(_vm.annotation.body)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }